import { NgModule } from 'ng-metadata/core';
import { HeroComponent } from './hero.component';

/**
 * @ngdoc module
 * @name mw.components.hero
 * @description
 *
 * Big title with dropdown
 */
@NgModule({
    declarations: [ HeroComponent ]
})
export class HeroModule {}




// WEBPACK FOOTER //
// ./src/lib/components/hero/hero.module.ts